// MCP skill packs for the Launchpad MCP panel. Full skill bodies live under
// public/mcp-skills/<id>/SKILL.md (downloadPath).

// Ends every copyable prompt so a paste before connecting gets a nudge back
// instead of an answer made up from general knowledge.
export const MCP_NOT_CONNECTED_LINE = "If the Foreplay tools aren't available, stop and tell me to connect Foreplay first at https://public.api.foreplay.co/mcp."

export const MCP_SKILLS = [
  {
    id: 'evergreen-hunter',
    title: 'Evergreen Hunter',
    oneLiner: '90d+ survivors, clustered by hook, with transcripts on the winners.',
    wow: 'You leave with durable hook patterns — not a dump of last week\'s tests.',
    needs: ['Discovery'],
    tools: ['brand ads', 'discovery search', 'transcripts', 'display_ad_results'],
    downloadPath: '/mcp-skills/evergreen-hunter/SKILL.md',
    activationPrompt:
      `Using the Foreplay MCP, run the Evergreen Hunter skill: find competitor ads live 90+ days, cluster by hook, pull transcripts for the top videos, and show them with display_ad_results. End with 3 stealable patterns. ${MCP_NOT_CONNECTED_LINE}`
  },
  {
    id: 'weekly-competitor-sweep',
    title: 'Weekly Competitor Sweep',
    oneLiner: 'Your Spyder watchlist\'s last 7 days as a Slack-ready Monday brief.',
    wow: 'A ritual brief from brands you already track — launches, velocity, new hooks and one thing to test.',
    needs: ['Spyder'],
    tools: ['spyder watchlist', 'brand ads', 'transcripts', 'lens metrics', 'display_ad_results'],
    downloadPath: '/mcp-skills/weekly-competitor-sweep/SKILL.md',
    activationPrompt:
      `Using the Foreplay MCP, run the Weekly Competitor Sweep skill: read my Spyder watchlist, summarize the last 7 days (launches, velocity shifts, new hooks), show must-see ads, and output a Slack-ready brief that ends with one "test this week" action. ${MCP_NOT_CONNECTED_LINE}`
  },
  {
    id: 'creative-test-autopsy',
    title: 'Creative Test Autopsy',
    oneLiner: 'Breakouts vs evergreen — what they\'re testing vs what they\'re scaling.',
    wow: 'Strategist vocabulary on a tracked brand: testing thesis vs scaling thesis.',
    needs: ['Spyder'],
    tools: ['spyder watchlist', 'brand ads', 'transcripts', 'display_ad_results'],
    downloadPath: '/mcp-skills/creative-test-autopsy/SKILL.md',
    activationPrompt:
      `Using the Foreplay MCP, run the Creative Test Autopsy skill: split a Spyder-tracked brand into breakout vs evergreen, cluster each bucket, show examples, and state what to copy vs ignore. ${MCP_NOT_CONNECTED_LINE}`
  },
  {
    id: 'angle-theft-detector',
    title: 'Angle Theft Detector',
    oneLiner: 'Lens winners matched to Discovery lookalikes — is your angle crowded?',
    wow: 'Account performance × public market twins in one pass (Foreplay-only).',
    needs: ['Lens', 'Discovery'],
    tools: ['lens metrics', 'discovery search', 'transcripts', 'display_ad_results'],
    downloadPath: '/mcp-skills/angle-theft-detector/SKILL.md',
    activationPrompt:
      `Using the Foreplay MCP, run the Angle Theft Detector skill: pull my top Lens hooks, find Discovery lookalikes, show side-by-side ads, and call saturation (unique / contested / crowded). ${MCP_NOT_CONNECTED_LINE}`
  },
  {
    id: 'board-brief-factory',
    title: 'Board → Brief Factory',
    oneLiner: 'Named board → production brief with 3 angles grounded in your refs.',
    wow: 'Personal swipe IP becomes something creators can shoot from today.',
    needs: ['Board'],
    tools: ['boards', 'transcripts', 'display_ad_results'],
    downloadPath: '/mcp-skills/board-brief-factory/SKILL.md',
    activationPrompt:
      `Using the Foreplay MCP, run the Board → Brief Factory skill: open my named board, inventory refs, show the best ads, and write a production brief with exactly 3 angles and hook lines. ${MCP_NOT_CONNECTED_LINE}`
  },
  {
    id: 'hook-mining-lab',
    title: 'Hook Mining Lab',
    oneLiner: 'Niche × format → longevity-ranked hook bank from the 200M index.',
    wow: 'A ranked opener bank ready to mutate — not unsorted quotes.',
    needs: ['Discovery'],
    tools: ['discovery search', 'transcripts', 'display_ad_results'],
    downloadPath: '/mcp-skills/hook-mining-lab/SKILL.md',
    activationPrompt:
      `Using the Foreplay MCP, run the Hook Mining Lab skill: search Discovery by niche and format, rank hooks by days running, show exemplars, and give 5 mutated variants to test. ${MCP_NOT_CONNECTED_LINE}`
  },
  {
    id: 'domain-war-room',
    title: 'Domain War Room',
    oneLiner: 'domain_analysis packaged as ads, hooks, LPs, and attack angles.',
    wow: 'One domain in → structured war-room brief out, not a raw tool dump.',
    needs: ['Discovery'],
    tools: ['domain_analysis', 'brand ads', 'transcripts', 'display_ad_results'],
    downloadPath: '/mcp-skills/domain-war-room/SKILL.md',
    activationPrompt:
      `Using the Foreplay MCP, run the Domain War Room skill: run domain_analysis on the target site, deepen top ads with transcripts, display them, and package media mix, offers, and attack angles. ${MCP_NOT_CONNECTED_LINE}`
  }
]

// One install guide per MCP client, shown once under the skill grid.
export const MCP_SKILL_INSTALL = {
  claude: {
    steps: [
      'Download the SKILL.md for the skill you want.',
      'In Claude, open Skills (or project instructions) and upload the file.',
      'Paste the activation prompt, or ask Claude to "use the [skill name] skill on …".',
      'Make sure the Foreplay connector is enabled for the chat.'
    ]
  },
  chatgpt: {
    steps: [
      'Download the SKILL.md for the skill you want.',
      'Add it to your project instructions, or paste the file into the chat once.',
      'Run the activation prompt with the Foreplay app enabled for the conversation.',
      'Re-attach the skill if you start a new chat outside the project.'
    ]
  }
}
